import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  open() {
    if (this.hasDialogTarget) this.dialogTarget.showModal();
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close();
  }

  closeFromBackdrop(event) {
    if (event.target === this.dialogTarget) this.close();
  }
}
